import {Box} from "@material-ui/core";
import PropTypes from 'prop-types';

function Space(props) {
    const {vertical, spacing} = props;

    const marginX = vertical ? undefined : spacing / 2;
    const marginY = vertical ? spacing / 2 : undefined;

    return <Box className="appfuse-Space" marginX={marginX} marginY={marginY} />
}

Space.propTypes = {
    spacing: PropTypes.number,
    vertical: PropTypes.bool
}

Space.defaultProps = {
    spacing: 1,
    vertical: false
}

export default Space;